import React, { useRef, useState } from 'react';
import './FormDelivery.scss';
import './FormDelivery-media.scss';
import '../../services/CssTransitionModal.scss';
import Input from '../Input/Input';
import InputPhone from '../Input/InputPhone';
import Button from '../Button/Button';
import { ServiceData } from '../../redux/services/ServiceRedux';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import ErrorText from '../ErrorText/ErrorText';
import { ValidationFormItems } from '../../services/GlobalFunctions';
import { Props } from './interfaces';
import { IconCalculator, IconDownload } from './icons';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { CSSTransition } from 'react-transition-group';
import SuccessContent from '../SuccessContent/SuccessContent';
import { content } from '../../services/content';
import AgreementCheckboxes from '../AgreementCheckboxes/AgreementCheckboxes';
import ErrorTextBlocked from '../ErrorTextBlocked/ErrorTextBlocked';
import { Link } from '../Link/Link';

declare const ym: any;
declare const _tmr: any;

const FormDelivery = ({
  title = 'Доставка для Бизнеса день в день или на следующий день',
  description = '',
  calcButtonText = 'Быстрый расчет за 30 сек',
  calcButtonLink = '/calculator',
  downloadButtonText = 'скачать тарифы',
  downloadFileUrl = '',
  buttonText = 'Получить тариф под свой объём',
  eventMetrika = 'form_delivery',
  contactFormId,
  blockedSend,
  blockedSendLoaded,
}: Props) => {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('+7');
  const [successShow, setSuccessShow] = useState(false);
  const [errorPhone, setErrorPhone] = useState<string | null>(null);
  const [serverText, setServerText] = useState<string | null>(null);
  const [disableBtn, setDisableBtn] = useState(false);
  const [showBlockedError, setShowBlockedError] = useState(false);

  const [privacyPolicyAccepted, setPrivacyPolicyAccepted] = useState(false);
  const [allowMarketing, setAllowMarketing] = useState(false);
  const [privacyErrorCount, setPrivacyErrorCount] = useState(0);

  const success = () => {
    setName('');
    setPhone('+7');
    setSuccessShow(true);
    if (typeof ym !== 'undefined') {
      ym(26501373, 'reachGoal', eventMetrika + '_success');
    }
    if (typeof _tmr !== 'undefined') {
      _tmr.push({ type: 'reachGoal', id: 3737442, goal: 'vkamolead'});
    }
    setDisableBtn(false);
    setPrivacyPolicyAccepted(false);
    setAllowMarketing(false);
    setPrivacyErrorCount(0);
    setErrorPhone(null);
    setServerText(null);
  };

  const OnTimeOut = () => {
    setTimeout(() => setSuccessShow(false), 3000);
  };

  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleReCaptchaVerify = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!privacyPolicyAccepted) {
      setPrivacyErrorCount(c => c + 1);
      return;
    }

    setDisableBtn(true);
    setErrorPhone(null);
    setServerText(null);

    setShowBlockedError(false);
    if (blockedSend.state) {
      setShowBlockedError(true);
      setDisableBtn(false);
      return;
    }

    let token = '';
    if (!executeRecaptcha) {
      console.debug('recaptcha not set, ignoring');
    } else {
      token = await executeRecaptcha();
    }

    if (!ValidationFormItems({ phone, setErrorPhone })) {
      setDisableBtn(false);
      return;
    }

    ServiceData.submitForm({
      data: {
        name,
        phone,
        allowMarketing
      },
      success,
      setServerText,
      token,
      blockedSendLoaded,
      eventMetrika,
      contactFormId
    });
  };

  const nodeRefSuccess = useRef(null);
  const nodeRef = useRef(null);

  return (
    <div className="form-delivery">
      <CSSTransition
        in={successShow}
        nodeRef={nodeRefSuccess}
        timeout={{ appear: 200, enter: 0, exit: 200 }}
        classNames="css-transition-modal"
        unmountOnExit
        onEnter={OnTimeOut}
      >
        <SuccessContent refCss={nodeRefSuccess} />
      </CSSTransition>

      <CSSTransition
        in={!successShow}
        nodeRef={nodeRef}
        timeout={{ appear: 200, enter: 0, exit: 0 }}
        classNames="css-transition-content"
        unmountOnExit
      >
        <div ref={nodeRef} className="form-delivery__block">
          {/* Left Column - Blue Background */}
          <div className="form-delivery__left">
            <div className="form-delivery__left-content">
              <h2 className="form-delivery__title">{title}</h2>
              {description && (
                <p className="form-delivery__description body1" dangerouslySetInnerHTML={{ __html: description }} />
              )}

              <div className="form-delivery__buttons">
                <Link
                  to={calcButtonLink}
                  className="form-delivery__action-btn form-delivery__action-btn--calc"
                >
                  <span className="form-delivery__action-icon">{IconCalculator}</span>
                  <span>{calcButtonText}</span>
                </Link>

                {downloadFileUrl && (
                  <a
                    href={downloadFileUrl}
                    className="form-delivery__action-btn form-delivery__action-btn--download"
                    {...(downloadFileUrl.startsWith('#') ? {} : { target: '_blank', rel: 'noopener noreferrer', download: true })}
                  >
                    <span className="form-delivery__action-icon">{IconDownload}</span>
                    <span>{downloadButtonText}</span>
                  </a>
                )}
              </div>
            </div>
          </div>

          {/* Right Column - Form */}
          <div className="form-delivery__right">
            <form onSubmit={handleReCaptchaVerify}>
              <Input
                label={content.formContacts.inputName}
                name="name"
                value={name}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
                error={null}
                marginTop={0}
              />

              <InputPhone
                label={content.formContacts.inputPhone}
                name="phone"
                value={phone}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setPhone(e.target.value);
                  if (errorPhone) setErrorPhone(null);
                  if (serverText) setServerText(null);
                }}
                error={errorPhone}
              />

              {showBlockedError && blockedSend.state && (
                <div className="form-delivery__error-blocked">
                  <ErrorTextBlocked counter={blockedSend.counter} />
                </div>
              )}

              <AgreementCheckboxes
                privacyChecked={privacyPolicyAccepted}
                onPrivacyChange={(checked) => {
                  setPrivacyPolicyAccepted(checked);
                  if (checked) setPrivacyErrorCount(0);
                }}
                marketingChecked={allowMarketing}
                onMarketingChange={setAllowMarketing}
                errorTrigger={privacyErrorCount}
              />

              <div className="form-delivery__button">
                {serverText && !errorPhone ? ErrorText(serverText, true) : null}
                <Button
                  text={buttonText}
                  widthAll
                  disabled={disableBtn}
                  showBlockedError={showBlockedError}
                />
              </div>
            </form>
          </div>
        </div>
      </CSSTransition>
    </div>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(FormDelivery));
